import { widgetUserBaseModel } from './crud';

export * from './types';

export const useWidgetUsersById = widgetUserBaseModel.fetchById();
export const useWidgetUsersByIds = widgetUserBaseModel.fetchByIds();
export const useWidgetUsersMany = widgetUserBaseModel.fetchMany();
export const useWidgetUsersCount = widgetUserBaseModel.count();
export const useWidgetUsersManyInfiniteQuery =
  widgetUserBaseModel.fetchPaginated();
export const useWidgetUsersUpdateOne = widgetUserBaseModel.edit();
export const useWidgetUsersCreateOne = widgetUserBaseModel.create();
export const useWidgetUsersRemoveOne = widgetUserBaseModel.delete();
export const useWidgetUsersRemoveByIds = widgetUserBaseModel.deleteByIds();

export const useWidgetUsersByIdV2 = widgetUserBaseModel.fetchByIdV2();
export const useWidgetUsersByIdsV2 = widgetUserBaseModel.fetchByIdsV2();
export const useWidgetUsersManyV2 = widgetUserBaseModel.fetchManyV2();
export const useWidgetUsersCountV2 = widgetUserBaseModel.countV2();
export const useWidgetUsersManyInfiniteQueryV2 =
  widgetUserBaseModel.fetchPaginatedV2();
export const useWidgetUsersUpdateOneV2 = widgetUserBaseModel.editV2();
export const useWidgetUsersCreateOneV2 = widgetUserBaseModel.createV2();
export const useWidgetUsersRemoveOneV2 = widgetUserBaseModel.deleteV2();
export const useWidgetUsersRemoveByIdsV2 = widgetUserBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useWidgetUserById = widgetUserBaseModel.fetchById();
export const useWidgetUserByIds = widgetUserBaseModel.fetchByIds();
export const useWidgetUserMany = widgetUserBaseModel.fetchMany();
export const useWidgetUserCount = widgetUserBaseModel.count();
export const useWidgetUserPagination = widgetUserBaseModel.fetchPaginated();
export const useWidgetUserUpdateOne = widgetUserBaseModel.edit();
export const useWidgetUserCreateOne = widgetUserBaseModel.create();
export const useWidgetUserRemoveOne = widgetUserBaseModel.delete();
export const useWidgetUserRemoveByIds = widgetUserBaseModel.deleteByIds();

export const useWidgetUserByIdV2 = widgetUserBaseModel.fetchByIdV2();
export const useWidgetUserByIdsV2 = widgetUserBaseModel.fetchByIdsV2();
export const useWidgetUserManyV2 = widgetUserBaseModel.fetchManyV2();
export const useWidgetUserCountV2 = widgetUserBaseModel.countV2();
export const useWidgetUserPaginationV2 = widgetUserBaseModel.fetchPaginatedV2();
export const useWidgetUserUpdateOneV2 = widgetUserBaseModel.editV2();
export const useWidgetUserCreateOneV2 = widgetUserBaseModel.createV2();
export const useWidgetUserRemoveOneV2 = widgetUserBaseModel.deleteV2();
export const useWidgetUserRemoveByIdsV2 = widgetUserBaseModel.deleteByIdsV2();
